import React, { useState, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useLocation } from 'react-router';
import { FormInstance } from 'antd/es/form';
import { RootState } from 'modules';
import { useRecoilState, useRecoilValue } from 'recoil';
import EditorComponent from 'components/base/EditorComponent';
import { getUrlQuery } from 'libs/utils';
import { TQuizbody, TUserViewDescription, TCurrentProcess, TCurrentProcessProps } from 'modules/learning';
import { EQuizProcessName } from 'modules/learning/quizTypes';
import {
  currentProcessState,
  isGradedState,
  descriptionKeyState,
  // referenceElementState
} from 'modules/learning/recoilState';
import { Form, Tabs } from 'antd';
import styled from 'styled-components';
import { device, Colors } from 'GlobalStyles';

const { TabPane } = Tabs;

function KaitusAssessmentDescription({ form }: { form: FormInstance }) {
  const [key, setKey] = useRecoilState(descriptionKeyState);
  const location = useLocation();
  const { operation, id } = getUrlQuery(location.search);
  const [descriptionContent, setDescriptionContent] = useState<string>('');
  const [commentaryContent, setCommentaryContent] = useState<string>('');
  const quizState = useSelector((store: RootState) => store.createQuizReducer);
  const [userViewDescription, setUserViewDescription] = useState<TUserViewDescription>({
    description: '',
    commentary: '',
  });
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const currentProcess = useRecoilValue<TCurrentProcess>(currentProcessState);
  const isGraded = useRecoilValue<boolean>(isGradedState);

  useEffect(() => {
    const descriptionEditData = quizState.quiz_body.find((el: any) => el.is_explanation === false)?.body; //문제에 들어오는 editor 스트링값
    const commentaryEditData = quizState.quiz_body.find((el: any) => el.is_explanation === true)?.body; //문제에 들어오는 editor 스트링값

    if (operation === 'view') {
      descriptionEditData &&
        setUserViewDescription((prev) => {
          return {
            ...prev,
            description: descriptionEditData,
          };
        });
      if (commentaryEditData) {
        setUserViewDescription((prev) => {
          return {
            ...prev,
            commentary: commentaryEditData,
          };
        });
      } else if (!commentaryEditData) {
        //멤버십 사용자이면서 아직 채점을 하지 않은 사람의 경우
        if (currentUser?.is_drill_membership && !isGraded) {
          setUserViewDescription((prev) => {
            return {
              ...prev,
              commentary:
                '<p style="color:#AEAEAE">문제를 풀고 채점한 후 커리어스텝만의 해설을 확인하세요 :)</p>',
            };
          });
        } else if (!currentUser?.is_drill_membership) {
          //멤버십 사용자가 아닌경우
          setUserViewDescription((prev) => {
            return {
              ...prev,
              commentary:
                '<p style="color:#AEAEAE">멤버십에 가입하고 커리어스텝만의 해설을 확인하세요 :)</p>',
            };
          });
        }
      }
    }

    if (!!id && operation !== 'view' && quizState.id === Number(id)) {
      //실제 벨류 세팅 ==>form.setFields 해주지 않으면 아무런 수정 사항이 없고 등록 수정을 할 경우 undefined 값으로 들어간다
      form.setFields([
        { name: 'description', value: descriptionEditData },
        { name: 'commentary', value: commentaryEditData },
      ]);
      descriptionEditData && setDescriptionContent(descriptionEditData);
      commentaryEditData && setCommentaryContent(commentaryEditData);
    }
  }, [quizState.quiz_body]);

  useEffect(() => {
    //사용자가 멤버십일 경우에 quizState.quiz_body에 해설 string이 들어온다
    //이 경우에 해설 body 가 빈 string이 아니기 때문에 탭이 해설로 이동한다
    setKey('question');
    /*if (operation === 'view') {
      if (Boolean(quizState.quiz_body.find((el: TQuizbody) => el.is_explanation)?.body)) {
        setKey('commentary');
      } else {
        //풀었던 문제 들어간 뒤 풀지 않았던 문제로 들어가면  setKey('commentary');가 되는것을 방지하기 위해 deps 바꿔주고
        //setKey('question');를 한번 더 넣어줌
        setKey('question');
      }
    }*/
  }, [quizState.quiz_body.find((el: TQuizbody) => el.is_explanation)?.body]);

  useEffect(() => {
    setKey('question');
    /*if (operation === 'view') {
      if (isGraded) {
        // 다시풀기 후 채점하기를 눌러을  때 => isGraded
        if (currentUser?.is_drill_membership || quizState.is_sample) setKey('commentary');
      } else {
        setKey('question');
      }
    }*/
  }, [isGraded]);

  //도움말 문제, 해설 각각 탭 색깔을 다르게 주기 위해 pop이라는 attribute를 임의로 넣어준다
  useEffect(() => {
    const allTabs = document.querySelector('.quiz_description_wrapper')?.querySelectorAll('.ant-tabs-tab');
    allTabs && allTabs[0].setAttribute('pop', 'question');
  }, []);

  return (
    <QuizDescriptionWrapper
      className='quiz_description_wrapper'
      currentProcessName={currentProcess.name}
      currentProcess={
        currentProcess.name === EQuizProcessName.Question ||
        currentProcess.name === EQuizProcessName.Commentary
      }
    >
      <Tabs
        activeKey={key}
        // centered={true}
      >
        <TabPane tab={'문제'} key={'question'}>
          <StyledQuestionTabWrapper
            id={`${EQuizProcessName.Question}_popper_reference`}
            // ref={setReferenceElement as any}
            currentProcess={
              currentProcess.name === EQuizProcessName.Question ||
              currentProcess.name === EQuizProcessName.Commentary
            }
          >
            {operation === 'view' ? (
              <StyleDescriptionHtmlWrapper>
                <div
                  style={{ padding: '15px' }}
                  dangerouslySetInnerHTML={{
                    __html: userViewDescription.description,
                  }}
                />
              </StyleDescriptionHtmlWrapper>
            ) : (
              <section style={{ padding: '15px' }}>
                <Form.Item
                  // shouldUpdate={true}
                  name='description'
                  rules={[{ required: true, message: '문제를 입력해주세요' }]}
                >
                  {/* edit 일 경우에는 기존에 썼던 정보 가져오도록 */}
                  <EditorComponent content={descriptionContent} onChange={setDescriptionContent} />
                </Form.Item>
              </section>
            )}
          </StyledQuestionTabWrapper>
        </TabPane>
      </Tabs>
    </QuizDescriptionWrapper>
  );
}

export default KaitusAssessmentDescription;

type TQuizDescriptionWrapperProps = {
  currentProcessName?: string;
  currentProcess?: boolean;
};

const QuizDescriptionWrapper = styled.div<TQuizDescriptionWrapperProps>`
  border: 1px solid ${Colors.grey1};
  border-right: none;
  height: 800px;
  @media screen and ${device.md} {
    border-right: 1px solid ${Colors.grey1};
  }

  & .ant-tabs-nav-wrap {
    ${(props) => props.currentProcess && 'z-index: 90;'}
    @media screen and ${device.sm} {
      z-index: unset
  }
  }

  & .ant-tabs-tab[pop='question'] {
    ${(props) => props.currentProcessName === 'question' && `background-color: ${Colors.white};`};
  }
  & .ant-tabs-tab[pop='commentary'] {
    ${(props) => props.currentProcessName === 'commentary' && `background-color: ${Colors.white};`};
  }
`;

const StyledQuestionTabWrapper = styled.section<TCurrentProcessProps>`
height: 750px;
overflow: scroll;
 //💜 도움말에서 해당 파트일 때
 position: relative; //z-index안먹었을 때 해결법
${(props) => props.currentProcess && 'z-index: 90;'}
background-color: ${Colors.white};
@media screen and ${device.sm} {
    ${(props) => props.currentProcess && 'z-index: unset;'}
  }

`;

const StyledCommentaryTabWrapper = styled.section<TCurrentProcessProps>`
  height: 750px;
  overflow: scroll;
   //💜 도움말에서 해당 파트일 때
   position: relative; //z-index안먹었을 때 해결법
  ${(props) => props.currentProcess && 'z-index: 90;'}
  background-color: ${Colors.white};
  @media screen and ${device.sm} {
    ${(props) => props.currentProcess && 'z-index: unset;'}
  }
`;

const StyleDescriptionHtmlWrapper = styled.div<TCurrentProcessProps>``;
